import {useCallback, useRef, useState} from 'react';

export const useMouseOver = (timeout?: number) => {
    const [isMouseOverComponent, setIsMouseOverComponent] = useState(false);
    const timeoutRef = useRef<ReturnType<typeof setTimeout>>();

    const handleMouseEnter = useCallback(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsMouseOverComponent(true);
    }, []);

    const handleMouseExit = useCallback(() => {
        timeoutRef.current = setTimeout(() => {
            setIsMouseOverComponent(false);
        }, timeout ?? 0);
    }, [timeout]);

    return {
        isMouseOverComponent,
        handleMouseEnter,
        handleMouseExit,
    };
};
